import {contentTags} from './constants';

export const PHONEME_STORY_TYPES = [
	contentTags.EARLY_READER_UP_AND_DOWN,
	contentTags.EARLY_READER_LETTER_FLIES,
];